import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import mitt from 'mitt'
import vant from './plugins/vant'
import '@/assets/fonts/iconfont.css'
import { loading } from '@/utils/loading'
import i18n from './locales'
import { VueMasonryPlugin } from 'vue-masonry'
// import * as Sentry from '@sentry/vue'
import track from './utils/track'

track()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(vant).use(i18n).use(pinia).use(router).use(VueMasonryPlugin).mount('#app')

app.config.globalProperties.$loading = loading
app.config.globalProperties.$bus = mitt()
app.config.errorHandler = (err) => {
  console.log('errorHandler', err)
  // 处理错误，例如：报告给一个服务
}

// 全局兜底：确保 window.Wxsdk.wechatShare 在任何环境都存在空实现
if (!window.Wxsdk || typeof window.Wxsdk.wechatShare !== 'function') {
  window.Wxsdk = window.Wxsdk || {}
  window.Wxsdk.wechatShare = () => { }
}
